import { atomFamily } from 'recoil';

/**
 * open, setOpen을 openId하나로 관리
 */
export const simpleOpenAtomFamily = atomFamily({
  key: 'simpleOpenAtomFamily',
  default: false,
});
